import { Outlet, ScrollRestoration, useLocation } from "react-router-dom";

import styles from './App.module.css';
import goToTopImg from './assets/icons/TopArrow.svg';

import HeaderComponent from './components/Header/Header';
import FooterComponent from './components/Footer/Footer';
import MobileNavBar from "./components/MobileNavBar/MobileNavBar";

function App() {
  const location = useLocation();

  // When the user clicks on the button, scroll to the top of the document
  function topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }


  return (
    <main className='grid-container'>
      {(location.pathname !== '/') && <MobileNavBar />}

      <header id='navBarPanel' className={styles.header + ' grid-container'}>
        <HeaderComponent />
      </header>

      <Outlet />

      <FooterComponent />

      <ScrollRestoration />

      <button id="btnGoToTop" title="Go to top" onClick={topFunction}>
        <img src={goToTopImg} alt="Go to top icon" />
      </button>
    </main>
  );
}


export default App;
